module.exports = __webpack_public_path__ + "img/event_transformation_indus_feminin.d775d4e4.png";